<script setup>
import AboutModal from "@/components/general/AboutModal.vue";
import {onMounted, ref} from "vue";

const aboutModalOpen = ref(false);

onMounted(() => {
  const classNames = [
    "right__link--1",
    "right__link--2",
    "right__link--3",
    "right__link--4",
    "right__link--5",
  ];

  classNames.forEach((className, index) => {
    setTimeout(() => {
      const el = document.querySelector(`.${className}`);
      if (el) {
        el.classList.add("right__link--anim");
      }
    }, 750 * (index + 1));
  });
});
</script>

<template>
  <div class="hero container-big">
    <div class="hero-content container">
      <div class="left">
        <p class="left__title">Погрузитесь в виртуальный мир МетаВДНХ!</p>
        <p class="left__text">
          Посетите уникальные мероприятия <br />
          и прогуляйтесь по цифровой копии ВДНХ вместе с друзьями не выходя из
          дома!
        </p>
        <div class="left-links desk">
          <router-link :to="{name: 'authorizationPage'}" class="link"
            >Посетить МетаВДНХ</router-link
          >
          <button @click="aboutModalOpen = true" class="link">Подробнее</button>
        </div>
      </div>
      <div class="right">
        <div class="right-top">
          <!-- <a href="#NewYear" class="right__link right__link--1">
            <img
              src="@/assets/9may/hero/img7.png"
              alt=""
              class="right__link-img" />
            <div class="right__link-fill">
              <div class="right__link-bg"></div>
              <img
                src="@/assets/9may/hero/info-7.png"
                alt=""
                class="right__link-content" />
              <p class="right__link-text">Подробнее >></p>
            </div>
          </a> -->
          <a href="#Chronicles" class="right__link right__link--2">
            <img
              src="@/assets/9may/hero/img3.png"
              alt=""
              class="right__link-img" />
            <div class="right__link-fill">
              <div class="right__link-bg"></div>
              <img
                src="@/assets/9may/hero/info-3.png"
                alt=""
                class="right__link-content" />
              <p class="right__link-text">Подробнее >></p>
            </div>
          </a>
          <a href="#russiaForum" class="right__link right__link--3">
            <img
              src="@/assets/9may/hero/img1.png"
              alt=""
              class="right__link-img" />
            <div class="right__link-fill">
              <div class="right__link-bg"></div>
              <img
                src="@/assets/9may/hero/info-1.png"
                alt=""
                class="right__link-content" />
              <p class="right__link-text">Подробнее >></p>
            </div>
          </a>
        </div>
        <div class="right-bottom">
          <a href="#Vanya" class="right__link right__link--4">
            <img
              src="@/assets/9may/hero/img4.png"
              alt=""
              class="right__link-img" />
            <div class="right__link-fill">
              <div class="right__link-bg"></div>
              <img
                src="@/assets/9may/hero/info-4.png"
                alt=""
                class="right__link-content" />
              <p class="right__link-text">Подробнее >></p>
            </div>
          </a>
          <a href="#walk" class="right__link right__link--5">
            <img
              src="@/assets/9may/hero/img5.png"
              alt=""
              class="right__link-img" />
            <div class="right__link-fill">
              <div class="right__link-bg"></div>
              <img
                src="@/assets/9may/hero/info-5.png"
                alt=""
                class="right__link-content" />
              <p class="right__link-text">Подробнее >></p>
            </div>
          </a>
        </div>
      </div>
      <div class="left-links mob">
        <router-link :to="{name: 'authorizationPage'}" class="link"
          >Посетить МетаВДНХ</router-link
        >
        <button @click="aboutModalOpen = true" class="link">Подробнее</button>
      </div>
    </div>
  </div>
  <AboutModal
    v-if="aboutModalOpen"
    @close="aboutModalOpen = false"></AboutModal>
</template>

<style scoped lang="scss">
.container-big {
  max-width: 90rem;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 1100px) {
    max-width: 44rem;
  }
}
.hero {
  background: url("@/assets/9may/hero/hero-bg.svg");
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 37px !important;
  padding-bottom: 46px !important;
  border-radius: 48px;
  &-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  @media (max-width: 1100px) {
    &-content {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

.left {
  max-width: 528px;
  width: 100%;
  &__title {
    font-size: 32px;
    line-height: 140%;
    color: #fff;
    font-weight: 700;
  }
  &__text {
    margin-top: 16px;
    font-size: 26px;
    line-height: 140%;
    color: #fff;
  }
  &-links {
    margin-top: 53px;
    display: flex;
    flex-direction: column;
    max-width: 469px;
    gap: 19px;
    .link {
      width: 100%;
      padding: 14px;
      font-size: 20px;
      line-height: 140%;
      justify-content: center;
    }
  }
  @media (max-width: 1100px) {
    max-width: 100%;
    &__title {
      font-size: 24px;
    }
    &__text {
      margin-top: 12px;
      font-size: 14px;
      br {
        display: none;
      }
    }
    &-links {
      margin-top: 0;
      max-width: 100%;
      width: 100%;
      gap: 12px;
      .link {
        padding: 0.8125rem 1.25rem;
        font-size: 14px;
        line-height: 140%;
        gap: 0.5rem;
        position: relative;
        z-index: 2;
      }
    }
  }
}
.right {
  &-top {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  &-bottom {
    margin-top: 16px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  &__link {
    scroll-margin-top: 8rem;
    transition: all 0.5s ease-in-out;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    &-fill {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: all 0.5s ease-in-out;
    }

    &--4 {
      .right__link-content {
        transform: rotate(-15deg);
      }
    }
    &-bg {
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      position: absolute;
      border-radius: 32px;
      background: linear-gradient(
          180deg,
          rgba(102, 102, 102, 0) 0%,
          #00288c 73.91%
        ),
        rgba(0, 0, 0, 0.2);
    }
    &-text {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px 27px 16px;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      text-decoration: underline;
      text-decoration-skip-ink: none;
      text-align: center;
      color: rgba(255, 255, 255, 0.5);
      z-index: 2;
      transition: all 0.5s ease-in-out;
      text-align: center;
      &--small {
        font-size: 20px;
      }
    }
    &-content {
      position: absolute;
      z-index: 1;
      transition: all 0.5s ease-in-out;
      max-width: calc(100% - 32px);
    }
    &:hover {
      opacity: 1;
      .right__link-fill {
        opacity: 1;
      }
    }
    &-img {
      border-radius: 32px;
      object-fit: cover;
      object-position: center;
      height: 100%;
    }
  }
  @media (max-width: 1000px) {
    &__link {
      &--anim {
        .right__link-fill {
          animation: fadeIn 4s infinite;
        }
      }
      &-text {
        display: none;
      }

      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    }
  }
  @media (max-width: 700px) {
    min-height: 77vw;
  }
}

.desk {
  @media (max-width: 1000px) {
    display: none !important;
  }
}

.mob {
  display: none !important;
  @media (max-width: 1000px) {
    display: flex !important;
  }
}
</style>
